/** @file Actor: who is calling (token name or the UI session) and which scopes the token carries. */

export type Scope = 'read' | 'write' | 'render' | 'export';

export interface Actor {
  /** Token name (`claude-code`, `codex`, `cli`) or `tk` for the UI session. */
  name: string;
  scopes: Scope[];
}

export const ALL_SCOPES: readonly Scope[] = ['read', 'write', 'render', 'export'];
